import {
    AfterViewInit,
    ChangeDetectionStrategy,
    Component,
    Input,
    OnInit,
    TemplateRef,
    ViewChild,
} from '@angular/core';
import { ToastServicev2, ToastTemplateRegistryService } from '@app/shared/toast/services';

@Component({
  selector: 'app-toast-templates',
  template: `
    <!-- Default template for toasts with autohide -->
    <ng-template #toastHeader let-toastService="toastService" let-toastID="toastID" let-params="params">
      <i-feather class="me-2" name="bell"></i-feather>
      <strong class="me-auto">{{ 'REPSOFT!!!!' || 'Toast with Autohide' }}</strong>
      <small class="text-muted ms-2">{{ params?.timestamp || 'just now' }}</small>
      <button class="ms-2 mb-1 btn-close" type="button" aria-label="Close" (click)="toastService.remove(toastID)">
         <span aria-hidden="true">×</span>
      </button>
    </ng-template>
    <ng-template #toastHeader2 let-toastService="toastService" let-toastID="toastID" let-params="params">
      <i-feather class="me-2" name="bell"></i-feather>
      <strong class="me-auto">{{ params?.title || 'Toast with Autohide' }}</strong>
      <small class="text-muted ms-2">{{ params?.timestamp || 'just now' }}</small>
      <button class="ms-2 mb-1 btn-close" type="button" aria-label="Close" (click)="toastService.remove(toastID)">
         <span aria-hidden="true">×</span>
      </button>
    </ng-template>

    <!-- Default body template -->
    <ng-template #toastBody let-params="params">
      {{ 'HELLO THERE =======>>>> CEFERO!' || 'This is an example toast alert. It will dismiss automatically or you can dismiss it manually.' }}
    </ng-template>
    <ng-template #toastBody2 let-params="params">
      {{ params?.bodyText || 'This is an example toast alert. It will dismiss automatically or you can dismiss it manually.' }}
    </ng-template>

    <!-- Default template for toasts with manual dismissal -->
    <ng-template #toastHeaderManual let-toastService="toastService" let-toastID="toastID" let-params="params">
      <i-feather class="me-2" name="bell"></i-feather>
      <strong class="me-auto">{{ params?.title || 'Toast with Manual Dismissal' }}</strong>
      <small class="text-muted ms-2">{{ params?.timestamp || 'just now' }}</small>
      <button class="ms-2 mb-1 btn-close" type="button" aria-label="Close" (click)="toastService.remove(toastID)">
         <span aria-hidden="true">×</span>
      </button>
    </ng-template>
  `
})
export class ToastTemplatesComponent implements AfterViewInit {
  @ViewChild('toastHeader', { static: true }) toastHeader!: TemplateRef<any>;
  @ViewChild('toastBody', { static: true }) toastBody!: TemplateRef<any>;
  @ViewChild('toastHeaderManual', { static: true }) toastHeaderManual!: TemplateRef<any>;

  constructor(private toastRegistryService: ToastTemplateRegistryService,
              private toastService: ToastServicev2) {}

  ngAfterViewInit(): void {
    // Register the templates globally
    this.toastRegistryService.registerTemplate('toastHeader', this.toastHeader);
    this.toastRegistryService.registerTemplate('toastBody', this.toastBody);
    this.toastRegistryService.registerTemplate('toastHeaderManual', this.toastHeaderManual);
  }
}
